<template>
  <div class="d-flex flex-column justify-center align-center mb-6 mt-4">
    <SectionTitle :title="article.title ?? ''"/>
    <div :style="[{ 'background-image': article.bgImage && !display.mobile ? `url('${article.bgImage}')` : `url('${article.bgImageMobile}')` }]"
         :class="[article.imageAlignment == ImageAlignment.RIGHT
          ? 'bg-alternatingBackground rounded-lg flex-column-reverse'
          : 'flex-row-md-reverse flex-column',
        article.bgImage ? 'right-section-bg' : '',
          'd-flex right-section flex-lg-row justify-space-around align-center py-4 px-4 article-card text-wrap-balance',
        dark ? 'bg-alternatingBackground' : '']">
      <div
           :class="['my-4 mx-auto d-flex flex-column justify-center align-center', article.image ? 'article-content' : article.bgImage ? 'article-content-bg' : 'article-content-wide']">

        <template v-for="section in article.sections"
                  :key="section.id">
          <h3 v-if="section.heading"
              class="text-h5 font-weight-bold text-primary mb-6">
            {{ section.heading }}
          </h3>
          <p v-if="section.content"
             class="text-body-1 mt-2">
            <span v-html="highlightKeywords(section.content, section.keywords)"></span>
          </p>
          <ul v-if="section.listItems?.length"
              class="text-body-1">
            <li v-for="(item, index) in section.listItems"
                :key="index"
                class="text-body-1 mt-2">
              {{ item }}
            </li>
          </ul>
        </template>
        <div v-if="article.actionText"
             class="mt-4">
          <v-btn class="font-weight-bold text-primary bg-secondary"
                 :variant="article.actionVariant"
                 :density="display.mobile ? 'compact' : 'default'"
                 :size="display.mobile ? 'large' : 'large'"
                 :to="{ name: article.actionLink }">
            {{ article.actionText }}
            <v-icon v-if="article.actionIcon"
                    class="ml-2">
              {{ article.actionIcon }}
            </v-icon>
          </v-btn>
        </div>
      </div>
      <div v-if="article.image"
           class="d-flex justify-center align-center mx-auto rounded-lg article-image">
        <v-img :src="article.image"
               :alt="article.alt"
               class="rounded-lg"
               height="400px"
               cover></v-img>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { useDisplay } from 'vuetify';
import type { Article } from '~/models/articleModel';
import { ImageAlignment } from '~/models/imageAlignment';
const display = ref(useDisplay());

defineProps({
  article: {
    type: Object as PropType<Article>,
    required: true,
  },
  dark: {
    type: Boolean,
    default: false,
  },
});

function highlightKeywords(content: string, keywords: string[] | undefined): string {
  if (!keywords || keywords.length === 0) return content;
  const regex = new RegExp(`(${keywords.join('|')})`, 'gi');
  return content.replace(regex, (match) => `<strong>${match}</strong>`);
}
</script>

<style scoped>
.article-card {
  width: 100%;
  transition: transform 0.3s ease;
  position: relative;
}

.right-section-bg {
  background-size: cover;
  background-repeat: no-repeat;
  height: 600px;
  width: 100%;

  background-position: center;
  border-radius: 20px;
}

ul {
  list-style-type: none;
  padding-left: 20px;
}

ul li {
  position: relative;
  padding-left: 30px;
}

ul li::before {
  content: '';
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background-image: url('/broken_list2.jpeg');
  background-size: cover;
  background-repeat: no-repeat;
}

.article-content {
  max-width: 35%;
}

.article-content-bg {
  position: absolute;
  left: 27%;
  width: 50%;
  transform: translateX(-50%);
}

.article-content-wide {
  max-width: 95%;
  margin: 0 auto;
}

.article-image {
  height: 400px;
  width: 40%;
}

.text-wrap-balance {
  text-justify: inter-word;
}

@media screen and (max-width: 1279px) {
  .article-card {
    flex-direction: column;
    align-items: center;
  }

  .article-content {
    max-width: 85%;
  }

  .article-image {
    width: 90%;
    margin: 24px auto;
    max-height: 300px;
  }

  .text-wrap-balance {
    text-align: left;
  }

  .right-section-bg {
    position: relative;
    height: 800px;
  }

  .article-content-bg {
    position: absolute;
    left: 5%;
    transform: translateX(-5%);
    transform: translateY(-5%);
    bottom: 5%;
    width: 90%;
  }

}

@media screen and (max-width: 600px) {
  .right-section-bg {
    position: relative;
    height: 1000px;
  }

  .article-content-bg {
    position: absolute;
    left: 5%;
    transform: translateX(-5%);
    transform: translateY(-0%);
    bottom: 0%;
    width: 90%;
  }

}
</style>